import { defaultStore } from "../../stores/defaultStore";
import { getStringSizeInMB } from "../general-utils";

export const saveLayersToLocalStorage = (
  newLayers: Array<any>,
  successMessage?: string | null,
  warningMessage?: string | null
) => {
  const changeAlertMessage = defaultStore.getState().changeAlertMessage;
  const newLayersCleaned: any[] = [];
  newLayers.forEach((layer: any) => {
    if (layer.layers.length > 0) {
      newLayersCleaned.push(layer);
    }
  });
  const stringifiedParsedList = JSON.stringify(newLayersCleaned);
  try {
    localStorage.setItem("layersAddedByUser", stringifiedParsedList);
    if (successMessage && changeAlertMessage) {
      changeAlertMessage({
        message: successMessage,
        type: "success",
      });
    }
  } catch (error: any) {
    if (error.name === "QuotaExceededError") {
      const allLayersSize = getStringSizeInMB(stringifiedParsedList).toString();
      if (warningMessage && changeAlertMessage) {
        changeAlertMessage({
          message: `${warningMessage} ${allLayersSize} MB / 5 MB`,
          type: "warning",
        });
      }
      console.error(
        "localstorage_quota_exceeded",
        `${allLayersSize} MB / 5 MB`
      );
    }
  }
};

export function getLayersAddedByUser(): Array<any> {
  const allLayersAddedFromUser: any = localStorage.getItem("layersAddedByUser");
  return Array.isArray(JSON.parse(allLayersAddedFromUser))
    ? JSON.parse(allLayersAddedFromUser)
    : [];
}
